import ShoppingListButton from './ShoppingListButton';

export default ShoppingListButton;
